<template>
    <b-container>
        <div class="card ">
            <div class="card-header main-card">
                Exportación de datos
            </div>
            <div class="card-body d-flex flex-row">
                <div class="p-4">
                    <p>Listado de hoteles</p>
                    <b-button @click="exportHotels()" class="border" variant="light">
                        <i v-if="!loadingHotels" class="fa fa-hotel mr-2" aria-hidden="true"></i>
                        <i v-else class="fa fa-spinner fa-spin mr-2"></i>
                        <span>Exportar</span>
                    </b-button>
                </div>
                <div class="p-4">
                    <p>Listado de paradas</p>
                    <b-button @click="exportPickups()" class="border" variant="light">
                        <i v-if="!loadingPickups" class="fa fa-bus mr-2" aria-hidden="true"></i>
                        <i v-else class="fa fa-spinner fa-spin mr-2"></i>
                        <span>Exportar</span>
                    </b-button>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
import axios from "axios";
const baseUrl = process.env.VUE_APP_BASE_API;

export default {
    data() {
        return {
            loadingHotels: false,
            loadingPickups: false
        }
    },
    methods: {
        async exportHotels() {
            this.loadingHotels = true
            axios
                .get(baseUrl + '/export/hotels/',
                    { responseType: 'blob' }
                )
                .then(response => {
                    //let blob = new Blob([res.data], { type: res.headers['content-type'] });
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download", "listado-hoteles.csv"
                    )
                    document.body.appendChild(link);
                    link.click()
                    this.loadingHotels = false
                })
        },
        async exportPickups() {
            this.loadingPickups = true
            axios
                .get(baseUrl + '/export/pickups/',
                    { responseType: 'blob' }
                )
                .then(response => {
                    //let blob = new Blob([res.data], { type: res.headers['content-type'] });
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download", "listado-paradas.csv"
                    )
                    document.body.appendChild(link);
                    link.click()
                    this.loadingPickups = false
                })
        }
    }
}
</script>